/**
 * SuburbCheckbox
 * 
 * @Author: Focci
 * @Date: 2023-07-24 22:02:36
 * @Last Modified by: Focci
 * @Last Modified time: 2023-07-24 22:02:36
 */

'use client'

import PropTypes from 'prop-types'
import Scrollbar from '@comp/Scrollbar'
import { Checkbox } from '@comp/material'
import { useTranslations } from 'next-intl'
import { useCallback, useMemo, useState, useEffect } from 'react'
import { map, isArray } from 'lodash-es'

export default function SuburbCheckbox({
  single = false,
  data = [],
  value = [],
  onChange = () => {}
}) {
  const [checked, setChecked] = useState([])
  const ts = useTranslations('search')

  // 是否已全选
  const checkedAll = useMemo(
    () => data.length === checked.length, 
    [data.length, checked.length]
  )

  // 是否有选项被选择
  const indeterminate = useMemo(
    () => checked.length > 0 && !checkedAll, 
    [checkedAll, checked.length]
  )
  
  // checkbox change
  const handleChange = useCallback((item) => {
    if(single) {
      setChecked([item.value])
    } else {
      const index = checked.indexOf(item.value)
      if(index > -1) {
        setChecked((prev) => {
          prev.splice(index, 1)
          return [...prev]
        })
      } else {
        setChecked((prev) => [...prev, item.value])
      }
    }
  }, [checked, single])

  // 全选
  const handleCheckedAllChange = useCallback(() => {
    setChecked(checkedAll ? [] : map(data, 'value'))
  }, [checkedAll, data])

  useEffect(() => setChecked(isArray(value) ? value : []), [value])
  useEffect(() => onChange(checked), [checked, onChange])

  return (
    <>
      {!single && (
        <div className="ml-1 shrink-0 border-b border-b-solid pb-2">
          <label className="flex items-center gap-x-1 cursor-pointer">
            <Checkbox
              indeterminate={indeterminate}
              checked={checkedAll}
              onChange={handleCheckedAllChange}
            />
            <span className="pr-4 text-f.7">{ts('selectAll')}</span>
          </label>
        </div>
      )}
      <div className="flex-1 mt-2">
        <Scrollbar>
          <div className="grid grid-cols-1 md:grid-cols-2">
            {data.map((item) => (
              <label
                key={item.value} 
                className="flex items-center gap-x-1 cursor-pointer p-1"
              >
                <Checkbox
                  checked={checked.indexOf(item.value) > -1}
                  onChange={() => handleChange(item)}
                />
                <span className="pr-4 text-f.7">{item.label}</span>
              </label>
            ))}
          </div>
        </Scrollbar>
      </div>
    </>
  )
}

SuburbCheckbox.propTypes = {
  data: PropTypes.array,
  value: PropTypes.any,
  onChange: PropTypes.func,
}
